<template>
  <div>
    <h1 class="margin-bottom">
      <span class="en-title">TO WHOM IT MAY CONCERN</span>
    </h1>
    <div class="tem-son-content">
      <div class="flex right line-feed">
        <div>This is to certify that</div>
        <div class="dotted"></div>
        <div>has been employed by</div>
        <div style="width: 5%"></div>
      </div>
      <div class="flex right line-feed" style="margin-bottom: 70px">
        <div class="dotted"></div>
        <div>since</div>
        <div class="dotted"></div>
        <div>until present.</div>
      </div>
      <div class="flex left line-feed" style="margin-bottom: 80px">
        <div>Should there be any queries, please contact us at the address and telephone number given below.</div>
      </div>
      <div class="flex left line-feed">
        <div>Yours sincerely,</div>
      </div>
    </div>

    <div class="flex tem-son-content">
      <div style="flex: 1">
        <img v-if="form.sign" style="width: 100%" :src="form.sign" alt="负责人签名" />
      </div>
      <div style="flex: 1; margin-left: 20px">
        <img v-if="form.c_sign" style="width: 100%" :src="form.c_sign" alt="企业签章" />
      </div>
      <div style="width: 60%"></div>
    </div>
    <div class="margin-bottom tem-son-content">
      <p>({{ form[currentTem.name] }})</p>
      <p>
        {{ form.job }}
      </p>
      <div style="width: 60%"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    lang: {
      type: String,
      default: 'th'
    },
    currentTem: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
